<template>
  <div :class="$options.name">
    <div class="pk-detail-con" :style="'width:'+ perStyle.pkDetailCon +'px;'">
    <div class="percentage">
		<span class="vote-nums vnums-l" :style="'font-size:'+ perStyle.voteNums +'px;'"><font v-if="ucount>0||status!=''">{{percentageValue}}%</font></span>
		<span class="tips" v-if="!guessStatus" :style="'font-size:'+ perStyle.tips +'px;'">{{oddsCn?oddsCnres:'让球'}}</span>
		<span class="tips" v-else :style="'font-size:'+ perStyle.tips +'px;'">{{oddsCn?oddsCn.b_odds_cn:'大小'}}</span>
		<span class="vote-nums vnums-r" :style="'font-size:'+ perStyle.voteNums +'px;'"><font v-if="ucount>0||status!=''">{{residue}}%</font></span>
	</div>

    <div class="progress" :style="'height:'+ perStyle.progress +'px;'">
      <div class="progress-bar" :style="'width:'+percentageValue+'%;height:'+ perStyle.progressBar +'px;'">
      </div>
    </div>
</div>
  </div>
</template>

<script>
export default {
  name: "Progress",
  props: [],
  data() {
    return {};
  },
  computed:{
	  residue(){
		  return (100-this.percentageValue)
	  },
	  oddsCnres(){
		  if(this.oddsCn==null) return
		  let ind = (this.oddsCn.a_odds_cn).indexOf('<font color=red>*</font>');
		  let n =  this.oddsCn.a_odds_cn.replaceAll('<font color=red>*</font>','')
		  if (ind!=-1) {
		  	return '受'+n
		  } else{
		  	return n
		  }
	  }
  },

  props:{
	  guessStatus:Number,
    status:String||null,
    ucount:Number,
	  percentageValue:Number,
	  perStyle:Object,
	  oddsCn:Object||null
  }
};
</script>

<style lang="less" scoped>
.Progress {
    .pk-detail-con {
        align-items: center;
        justify-content: center;
        position: relative;
		margin-bottom: 4px;
    }
	.percentage {
		display: flex;
		height: 24px;
		align-items: center;
		justify-content: space-between;
	}
    .progress {
        width: 100%;
        height: 7px;
        overflow: hidden;
        background-color: #2d99fb;
        border-radius: 19px;
    }
    .progress-bar{
        height: 7px;
        text-align: left;
        background-color: #facb58;
        -moz-transition: width .6s ease;
        -webkit-transition: width .6s ease;
        transition: width .6s ease
    }
    .progress, .progress-bar {
        background-image: -moz-linear-gradient(rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 50%);
        background-image: -webkit-linear-gradient(rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 50%);
        background-image: linear-gradient(rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0) 50%);
    }
	.tips{
		float: right;
		font-size: 13px;
		line-height: 28px;
		margin-bottom: 4px;
	}
    .lightning {
        width: 5px;
        height: 10px;
        float: right;
    }
    .team-name {
        position: absolute;
        top: 0;
        line-height: 10px;
        color: #f3eee1;
        letter-spacing: 1px;
        font-size: 14px;
    }
    .team-l {
        left: 23px;
    }
    .team-r {
        right: 23px;
    }
    .vote-nums {
        line-height: 2;
        color: #000;
        font-size: 12px;
    }
    .vnums-l {
        float: left;
        margin-left: 0px;
    }
    .vnums-r {
        float: right;
        margin-right: 0px;
  }
}
</style>
